import React, { useContext } from "react";
import { Data } from "./App";
import Heart from "./Heart";

const Fav = (props) => {
  const { favList, setFavList } = useContext(Data);

  const setFav = (e) => {
    fetch("/api/bookmark.php", {
      method: "post",
      body: JSON.stringify({ code: e.target.value }),
    })
      .then((res) => res.json())
      .then((json) => console.log(json))
      .catch((err) => {
        console.log(err);
      });

    const favNum = document.querySelector("#favNum");
    let currentNum = favList.length;
    if (favList.includes(e.target.value)) {
      let favCode = favList.filter((item) => item !== e.target.value);
      setFavList(() => favCode);
      if (currentNum === 1) {
        favNum.classList.remove("exist");
        favNum.textContent = "";
      } else {
        favNum.textContent--;
      }
    } else {
      setFavList(() => [...favList, e.target.value]);
      if (currentNum === 0) {
        favNum.classList.add("exist");
        favNum.textContent = 1;
      } else {
        favNum.textContent++;
      }
    }
  };

  return (
    <>
      <label>
        <input
          type="checkbox"
          checked={favList.includes(props.code) ? true : false}
          onChange={setFav}
          value={props.code}
          style={{ display: "none" }}
        />
        <Heart
          fill={favList.includes(props.code) ? "#1c1c1c" : "none"}
          size={props.size || 25}
          color="#1c1c1c"
        />
      </label>
    </>
  );
};

export default Fav;
